var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoBarLearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_74_1",
    "data-name": "Component 74 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.797,
    height: 18.478,
    viewBox: "0 0 30.797 18.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9043",
    "data-name": "Path 9043",
    d: "M29.457,68.328,16.705,64.205a4.218,4.218,0,0,0-2.613,0L1.34,68.328a1.918,1.918,0,0,0,0,3.658l1.43.462a3.824,3.824,0,0,0-.353.953,1.519,1.519,0,0,0,.005,2.755l-.869,5.383c-.077.481.188.937.546.937H4.06c.358,0,.624-.456.546-.937l-.868-5.383a1.531,1.531,0,0,0,.882-1.38,1.512,1.512,0,0,0-.646-1.221,2.286,2.286,0,0,1,.316-.616l2.573.832-.7,5.625c0,1.7,4.136,3.08,9.239,3.08s9.239-1.379,9.239-3.08l-.7-5.625,5.523-1.786a1.918,1.918,0,0,0,0-3.658ZM23.072,79.293c-.518.545-3.149,1.643-7.674,1.643s-7.156-1.1-7.674-1.643l.63-5.04,5.738,1.855a4.21,4.21,0,0,0,2.613,0l5.738-1.855.629,5.04Zm5.909-8.771L16.23,74.645a2.683,2.683,0,0,1-1.663,0L6.114,71.911l9.426-1.768a.77.77,0,1,0-.283-1.513L5.451,70.469a3.819,3.819,0,0,0-1.592.714l-2.045-.661a.379.379,0,0,1,0-.729l12.752-4.123a2.7,2.7,0,0,1,1.663,0l12.752,4.123A.379.379,0,0,1,28.981,70.522Z",
    transform: "translate(0 -63.998)",
    fill: "#484848"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBarLearning);
export default __webpack_public_path__ + "static/media/ico-bar-learning.b40421086d3d3b7fde1496fe0a8bab02.svg";
export { ForwardRef as ReactComponent };